const footerNav: { id: string; label: string }[] = [
  { id: 'facts', label: '影片档案' },
  { id: 'plot', label: '剧情介绍' },
  { id: 'cast', label: '演员表' },
  { id: 'series', label: '系列续集' },
  { id: 'scenes', label: '经典片段' },
  { id: 'similar', label: '类似电影' },
  { id: 'guide', label: '观影指南' },
  { id: 'faq', label: '常见问题' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col gap-8 lg:flex-row lg:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line" />
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">蜜桃成熟时电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-100/75">
              一站式了解 1993 年香港电影《蜜桃成熟时》的剧情、演员表、系列续集与同类影片推荐，为你的观影选择提供参考。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <a href="#top" className="transition-colors hover:text-accent-300">
                页面导航
              </a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-8 gap-y-2 sm:grid-cols-4 lg:grid-cols-2">
              {footerNav.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="font-label text-sm whitespace-nowrap text-background-100/75 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-10 rounded-lg border border-background-100/15 bg-white/5 p-4 text-xs leading-relaxed text-background-100/70">
          免责声明：本页为影视资料整理与观影导览，内容参考公开资料编写，不提供影片在线播放、下载或任何形式的资源链接。影片含成人内容并属香港第三级影片，仅适合成年观众；请确认自身年龄并遵守所在地的相关规定。
        </p>

        <div className="mt-6 flex flex-col gap-3 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-100/70">© 2026 蜜桃成熟时电影 · 观影指南</p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 font-label text-xs text-background-100/70 transition-colors hover:text-accent-300"
          >
            <i className="ri-arrow-up-line" />
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}